'use client';

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const NavMenu = () => {
      const pathname = usePathname();
      const [topMenu, setTopMenu] = useState("");

      useEffect(() => {
            if (pathname.split("/")?.[1]) {
                  setTopMenu(pathname.split("/")?.[1]);
            }
      }, [pathname]);

      const scrollToSection = (id) => {
            if (typeof document === "undefined") return;

            const el = document.getElementById(id);
            if (!el) return;

            el.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
            });
      };

      return (
            <ul className="ace-responsive-menu">
                  <li className="visible_list dropitem">
                        <a
                              className="list-item"
                              href="#"
                              onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection("features");
                                    setTopMenu("features");
                              }}
                        >
                              <span>
                                    Features
                              </span>
                        </a>
                  </li>
                  <li className="visible_list dropitem">
                        <a
                              className="list-item"
                              href="#"
                              onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection("platform-overview");
                                    setTopMenu("platform-overview");
                              }}
                        >
                              <span>
                                    Platform Overview
                              </span>
                        </a>
                  </li>
            </ul>
      );
};

export default NavMenu;
